import React from 'react';
import { TicketKey } from 'flow/types/EntityKeys';
import { useModal } from 'flow/contexts/ModalProvider';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { segmentTrack } from 'flow/actions/segment-actions';
import { TICKET_STRINGS } from 'flow/utils/segment-utils';
import useAppContext from 'flow/hooks/useAppContext';
import ButtonBase from 'flow/components/pbx/v2/detail-page/call-record-action/ButtonBase';
import MenuItem from 'flow/components/ui-components/MenuItem';
import { ButtonType } from '../types';
import { SegmentContextType } from 'flow/components/call-history-v2/types';
import IconButtonShowTicket from './IconButtonShowTicket';

interface Props {
    ticketKey: TicketKey;
    buttonType: ButtonType;
    segmentContext: SegmentContextType;
}

const ButtonShowTicket = ({ ticketKey, buttonType, segmentContext }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const { openModal } = useModal();

    const label = i18next.t('tickets.ticket.show_ticket');

    const onClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        dispatch(
            segmentTrack(TICKET_STRINGS.CLICK_SHOW_TICKET, {
                component: segmentContext,
            }),
        );
        openModal('ticketOverview', {
            ticketKey,
            segmentContext,
        });
    };

    if (buttonType === 'menuItem') {
        return (
            <MenuItem onClick={onClick} closeOnClick={true}>
                {label}
            </MenuItem>
        );
    }

    if (buttonType === 'icon') {
        return <IconButtonShowTicket label={label} onClick={onClick} />;
    }

    return (
        <ButtonBase
            onClick={onClick}
            disabled={false}
            iconKey="articleOutlined"
            label={label}
            className="bg-gray-200 text-gray-700 hover:bg-gray-300"
        />
    );
};

export default ButtonShowTicket;
